import { CSV_UPLOAD_TYPES } from "./common.constant";

export const sampleCsvData = {
    [CSV_UPLOAD_TYPES.USER]: {
        fileName: 'users_template.csv',
        apiEndPoint: '/user/addMultipleUsers',
        titles: {
            name: "Name",
            email: "Email",
            role: "Role",
            contact: "Contact",
            enable_mfa: "Enable MFA"

        },
        data: [
            {
                name: "Emily Watson",
                email: "emily.watson@example.com",
                role: "LOYYAL_ADMIN",
                contact: 9876543210,
                enable_mfa: false
            },
            {
                name: "James Carter",
                email: "james.carter@loyyal.com",
                role: "LOYYAL_ADMIN",
                contact: 9123456789,
                enable_mfa: false
            },
            {
                name: "Liam Thompson",
                email: "liam.thompson@example.com",
                role: "LOYYAL_ADMIN",
                contact: 9001122334,
                enable_mfa: false
            },
            {
                name: "Ava Johnson",
                email: "ava.johnson@loyyal.com",
                role: "LOYYAL_ADMIN",
                contact: 8888999911,
                enable_mfa: false
            }
        ]
    },
    [CSV_UPLOAD_TYPES.OFFER]: {
        fileName: 'merchant-offers_template.csv',
        apiEndPoint: '/merchant/addMultipleMerchantOffers',
        titles: {
            title: "Title",
            offer_url: "Offer Url",
            description: "Description",
            category_name: "Category Name",
            terms_and_conditions: "Terms And Conditions",
            start_date: "Start Date",
            end_date: "End Date",
            offer_image: "Offer Image",
            offer_eligibility: "Offer Eligibility",
            color_code: "Color Code"
        },
        data: [
            {
                title: "test",
                offer_url: "http://test.offer/",
                description: "desc",
                category_name: "GOLD",
                terms_and_conditions: "test terms and conditions",
                start_date: "2025-05-21",
                end_date: "2026-05-21",
                offer_image: "",
                offer_eligibility: "",
                color_code: ""
            },
            {
                title: "test",
                offer_url: "http://test.offer/",
                description: "desc",
                category_name: "GOLD",
                terms_and_conditions: "test terms and conditions",
                start_date: "2025-06-21",
                end_date: "2026-09-21",
                offer_image: "",
                offer_eligibility: "",
                color_code: ""
            }
        ]
    },
    [CSV_UPLOAD_TYPES.STORE]: {
        fileName: 'stores_template.csv',
        apiEndPoint: '/merchant/addMultipleMerchantStores',
        titles: {
            storeName: "StoreName",
            address: "Address",
            zip_code: "ZipCode",
            city: "City",
            latitude: "Latitude",
            longitude: "Longitude",
            epos: "Epos"
        },
        data: [
            {
                storeName: "Urban Threads",
                address: "indore schems no 271",
                zip_code: "451010",
                city: "indore",
                latitude: 22.719568,
                longitude: 75.857727,
                epos: true
            },
            {
                storeName: "The Style Loft",
                address: "indore schems no 272",
                zip_code: "451010",
                city: "bhopal",
                latitude: 22.719568,
                longitude: 75.857727,
                epos: true
            },
            {
                storeName: "NovaMart",
                address: "indore schems no 274",
                zip_code: "451010",
                city: "nagpur",
                latitude: 22.719568,
                longitude: 75.857727,
                epos: true
            },
            {
                storeName: "Trend & Co.",
                address: "indore schems no 274",
                zip_code: "451010",
                city: "dhule",
                latitude: 22.719568,
                longitude: 75.857727,
                epos: true
            },
        ]
    }
} 